import { graphql } from 'gatsby';
import React from 'react';
import Page from '.';
import { PageDataType } from 'types/Page';

interface Props {
  data: PageDataType;
}

const PageTemplate: React.StatelessComponent<Props> = ({ data }) => <Page {...data} />;

export default PageTemplate;

export const query = graphql`
  query($id: ID!) {
    wordpress {
      announcement: announcements(first: 1, where: {orderby: {field: DATE, order: ASC}}) {
        nodes {
          ...Announcement
        }
      }
      headerMenu: menus(where: { location: HEADER }) {
        nodes {
          ...Menu
        }
      }
      mainMenu: menus(where: { location: MAIN_MENU }) {
        nodes {
          ...Menu
        }
      }
      footerMenu: menus(where: { location: FOOTER }) {
        nodes {
          ...Menu
        }
      }
      secondaryFooterMenu: menus(where: { location: SECONDARY_FOOTER }) {
        nodes {
          ...Menu
        }
      }
      content: page(id: $id) {
        ...Page
      }
    }
  }
`;
